import React, { FunctionComponent } from 'react'
import moment from 'moment-timezone'

interface IRelativeTimeBubbleProps {
  date: string
  className?: string
  useTag?: boolean
  dataTooltip?: string
  dataTest?: string
}

export const RelativeTimeBubble: FunctionComponent<IRelativeTimeBubbleProps> = ({
  className,
  dataTest,
  dataTooltip,
  date,
  useTag,
}) => {
  const now = moment()
  const sec = now.diff(date, 'seconds')
  const min = now.diff(date, 'minutes')
  const hr = now.diff(date, 'hours')
  const day = now.diff(date, 'days')
  let relativeDate = `${day}d`
  let colors = ''

  if (sec <= 59) {
    relativeDate = '1m'
    colors = 'bg-success-light text-success'
  } else if (min <= 59) {
    relativeDate = `${min}m`
    colors = 'bg-success-light text-success'
  } else if (hr <= 23) {
    relativeDate = `${hr}h`
    colors = 'bg-warning-light text-warning'
  }

  const style = useTag ? `tag tag-round tag-small ${colors}` : ''

  return (
    <span className={`${style} ${className}`} data-test={dataTest} data-tooltip={dataTooltip}>
      {relativeDate}
    </span>
  )
}
